module.exports = __webpack_public_path__ + "img/cart_off-brands.a97d80fa.png";